import { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import useVersionControl from '@shared/hooks/useVersionControl';

import { HOTELS_SEARCH } from '@shared/helpers/routes';

import imageDesktop from '@shared/assets/ImageSearchForm.jpg';
import imageMobile from '@shared/assets/mobileHotels.svg';
import imageDesk from '@shared/assets/backgroundHotels.svg';

import useWindowSize from '@shared/hooks/useWindowsSize';

import { fetchHotelSearchResults } from '../helpers/fetchHotelSearchResults';

export const useHotelSearchForm = ({
  isDetailPage,
  isHomePage,
  setIsLoadingResults,
  setIsLoadingFastResults,
  setHotelSearchResults,
  setHotelFastSearchResults,
  setHotReferenceCities,
}) => {
  const { checkVersion } = useVersionControl(HOTELS_SEARCH);

  const dispatch = useDispatch();

  const screenSize = useWindowSize();

  const searchInfo = useSelector(store => store.search); //saveSearchDetails

  const pageConfiguration = useSelector(store => store.pageConfiguration);

  const { user } = useSelector(state => state.userInfo);

  const [hasError, setHasError] = useState(false);

  const [showRooms, setShowRooms] = useState(false);
  const [roomInfo, setRoomInfo] = useState(searchInfo?.roomInfo);

  const [quantity, setQuantity] = useState(searchInfo?.quantity);

  const [lodgingSelection, setLodgingSelection] = useState(
    searchInfo?.search_option
  );

  const [passengerValue, setpassengerValue] = useState({
    passengers: searchInfo?.passengers,
    total_passengers: searchInfo?.passengers.length,
  });

  const [calendarValue, setCalendarValue] = useState({
    check_in: searchInfo.checkIn,
    check_out: searchInfo.checkOut,
    total_nights: searchInfo.totalNights,
  });

  const bannerTdh = screenSize.width > 600 ? imageDesk : imageMobile;
  const image = pageConfiguration.id == 1 ? bannerTdh : imageDesktop;

  const updatepassengerValues = ({ passengers = [] }) => {
    passengers
      .filter(p => p.id_passenger_type === 1 && p?.age > 17)
      .forEach(pp => delete pp.age);
    const total_passengers = passengers.length;
    setpassengerValue({
      passengers,
      total_passengers,
    });
  };

  const updateCalendarValues = ({ check_in, check_out, total_nights }) => {
    setCalendarValue({ check_in, check_out, total_nights });
  };

  const fetchData = () =>
    fetchHotelSearchResults({
      calendarValue,
      passengerValue,
      lodgingSelection,
      searchInfo,
      isDetailPage,
      isHomePage,
      user,
      checkVersion,
      setIsLoadingResults,
      setIsLoadingFastResults,
      setHotelSearchResults,
      setHotelFastSearchResults,
      setHotReferenceCities,
    });

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setpassengerValue({
      passengers: searchInfo?.passengers,
      total_passengers: searchInfo?.passengers.length,
    });
    setCalendarValue({
      check_in: searchInfo.checkIn,
      check_out: searchInfo.checkOut,
      total_nights: searchInfo.totalNights,
    });

    setRoomInfo(searchInfo?.roomInfo);
    setQuantity(searchInfo?.quantity);

    setLodgingSelection(searchInfo?.search_option);
  }, [searchInfo]);

  return {
    hasError,
    roomInfo,
    setRoomInfo,
    showRooms,
    setShowRooms,
    quantity,
    setQuantity,
    updateCalendarValues,
    lodgingSelection,
    setLodgingSelection,
    updatepassengerValues,
    image,
    calendarValue,
    dispatch,
    passengerValue,
    setHasError,
    searchInfo,
    user,
    fetchData,
  };
};
